<template>
  <div class="notfound">
    <div class="centermiddle">
      <h1>Kunde inte hittas</h1>
      <h3>Sidan kunde inte hittas</h3>
    </div>

    <!-- A dead listing link (old Google result, old email) is the common way here:
         show what CAN be swapped right now instead of a dead end. Same list and
         markup as the front page (store getter frontPage, GET /api/v1/frontpage). -->
    <div v-if="frontPage.length" class="other-listings">
      <h2>Bostäder som går att byta just nu</h2>
      <div class="selected-listings-grid">
        <router-link v-for="bostad in frontPage" :key="bostad.id" :to="{ name: 'ad', params: { id: bostad.id } }" class="bostad-item">
          <div class="bostad-card">
            <img :src="'https://bytbostad.se/bilder/square/' + bostad.photo + '.jpg'" :alt="bostad.address" @error="errorImage">
            <div class="bostad-text">
              <span>{{ bostad.rooms }}:a {{ bostad.size }} m<sup>2</sup></span>
              {{ bostad.address }}<br />
              <span class="bostad-city">{{ bostad.city }}</span>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['frontPage'])
  },
  mounted() {
    // App.vue fetches the front page on load; this covers a hard load straight to /404.
    if (!this.frontPage.length) {
      this.$store.dispatch('getFrontpage').catch(() => {})
    }
  },
  methods: {
    errorImage(event) {
      event.target.src = '/img/nophoto.svg'
    }
  }
}
</script>

<style scoped lang="scss">
.centermiddle{
    display: flex;           /* establish flex container */
    flex-direction: column;  /* make main axis vertical */
    justify-content: center; /* center items vertically, in this case */
    align-items: center;     /* center items horizontally, in this case */
    min-height: 40vh;
    padding: 24px;
}
.other-listings h2 {
  text-align: center;
  padding: 8px 24px;
}
.selected-listings-grid{
  display:grid;grid-template-columns: repeat( auto-fit, minmax(250px, 1fr) );
  @media screen and (max-width: 650px) {
    grid-template-columns: repeat( auto-fit, minmax(150px, 1fr) );
  }
  max-width:1920px; grid-gap:8px; margin:auto;padding:8px;
}
.bostad-card {
  position:relative;background-color: blue;border-radius:8px;aspect-ratio: 1/1;cursor:pointer;overflow:hidden;
  img { object-fit: cover;width:100%;height:100%; }
  .bostad-text {
    color:white;background-color:rgba(0, 0, 0, 0.32); font-size:12px;position: absolute; top:0; bottom:0;right:0;left:0;display:grid;place-content: center;text-align: center;
  }
  .bostad-city { font-size:14px; }
}
</style>
